"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.googleDrive.title': 'Google Drive 集成',
    'settings.googleDrive.simpleDescription': '连接您的 Google Drive 以访问文件用于基于知识的 AI 支持',
    'settings.googleDrive.connectSimple': '连接到 Google Drive',
    'settings.googleDrive.clientId': '客户端 ID',
    'settings.googleDrive.clientIdPlaceholder': '输入您的 Google Drive 客户端 ID',
    'settings.googleDrive.clientIdHelp': '来自您的 Google Cloud Console OAuth 2.0 凭据的客户端 ID',
    'settings.googleDrive.clientSecret': '客户端密钥',
    'settings.googleDrive.clientSecretPlaceholder': '输入您的 Google Drive 客户端密钥',
    'settings.googleDrive.clientSecretHelp': '来自您的 Google Cloud Console OAuth 2.0 凭据的客户端密钥',
    'settings.googleDrive.redirectUri': '重定向 URI',
    'settings.googleDrive.redirectUriPlaceholder': 'https://您的域名.com/oauth/callback',
    'settings.googleDrive.redirectUriHelp': '在您的 Google Cloud Console 中配置的授权重定向 URI',
    'settings.googleDrive.enabled': '启用 Google Drive 集成',
    'settings.googleDrive.connect': '连接到 Google Drive',
    'settings.googleDrive.disconnect': '断开 Google Drive',
    'settings.googleDrive.connected': '已连接',
    'settings.googleDrive.notConnected': '未连接',
    'settings.googleDrive.howItWorks': '如何使用',
    'settings.googleDrive.instructions': '点击连接按钮打开 Google 登录窗口。授权后，您的 Google Drive 文件将可用于 AI 搜索。',
    'settings.googleDrive.authWindowOpened': 'Google Drive 授权窗口已打开。请完成身份验证过程。',
    'settings.googleDrive.failedToGetAuthUrl': '获取 Google Drive 授权 URL 失败',
    'settings.googleDrive.disconnectedSuccessfully': 'Google Drive 断开连接成功',
    'settings.googleDrive.failedToDisconnect': '断开 Google Drive 失败',
    'settings.googleDrive.gmail.label': 'Gmail 地址',
    'settings.googleDrive.gmail.placeholder': '请输入您的 Gmail 地址（例如：user@gmail.com）',
    'settings.googleDrive.gmail.help': '请输入与您的 Google Drive 账户关联的 Gmail 地址',
    'settings.googleDrive.gmail.invalid': '请输入有效的 Gmail 地址',
    'settings.googleDrive.gmail.enterValidGmail': '请输入有效的 Gmail 地址以连接',
    'settings.googleDrive.invalidGmail': '请在连接前输入有效的 Gmail 地址',
    'settings.googleDrive.enterGmailFirst': '请先输入 Gmail 地址',
    'settings.googleDrive.status.title': '连接状态',
    'settings.googleDrive.status.enabled': '集成状态',
    'settings.googleDrive.status.authentication': '认证状态',
    'settings.googleDrive.setup.title': '如何设置 Google Drive 集成',
    'settings.googleDrive.setup.step1': '前往 Google Cloud Console 并创建新项目或选择现有项目',
    'settings.googleDrive.setup.step2': '为您的项目启用 Google Drive API',
    'settings.googleDrive.setup.step3': '创建 OAuth 2.0 凭据（客户端 ID 和客户端密钥）',
    'settings.googleDrive.setup.step4': '将您的重定向 URI 添加到授权重定向 URI 列表中',
    'settings.googleDrive.setup.step5': '将客户端 ID、客户端密钥和重定向 URI 复制到上面的表单中',
    'settings.googleDrive.howItWorks.title': 'Google Drive 集成如何工作',
    'settings.googleDrive.howItWorks.step1': '点击"连接到 Google Drive"以授权访问您的 Google Drive',
    'settings.googleDrive.howItWorks.step2': '在提示时授予访问您文件的权限',
    'settings.googleDrive.howItWorks.step3': '您的 Google Drive 文件将可用于基于知识的 AI 辅助',
    'settings.googleDrive.connected.title': 'Google Drive 连接成功',
    'settings.googleDrive.connected.description': '您的 Google Drive 现已连接，文件可用于 AI 辅助',
};
